import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/campus-attendances', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const exportExcel = data => {
  return httpClient
    .post('/api/campus-attendances/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/campus-attendances', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const header = (Options = {}) => {
  return httpClient
    .get('/api/campus-attendances/get-header', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const latestCheckIn = studentId => {
  return httpClient
    .get(`/api/campus-attendances/${studentId}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = (studentId, datescan) => {
  return httpClient
    .delete(`/api/campus-attendances/${studentId}/${datescan}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  exportExcel,
  store,
  header,
  latestCheckIn,
  destroy
}
